/*----- Product Tabs Composant -----*/
class ProductTabs extends HTMLElement {
  constructor() {
    super();

    const tabBtns = this.querySelectorAll("a[data-trigger]");
    const tabContentInactive = this.querySelectorAll("div[data-target]");
    const tabTriggerInactive = this.querySelectorAll("a[data-trigger]");
    const descriptionTabContent = this.querySelector('div[data-target="description"]');

    const descBtn = this.querySelector("button.button.view-more");
    const descLink = this.querySelector("a.button.view-more");

    tabBtns.forEach(tabBtn => {
      tabBtn.addEventListener("click", () => {
        const tabTrigger = tabBtn.dataset.trigger;
        const tabContentActive = this.querySelector('div[data-target="' + tabTrigger + '"]');
        tabContentInactive.forEach(content => {
          content.classList.remove("active");
        });
        tabTriggerInactive.forEach(e => {
          e.classList.remove("active");
        });
        tabContentActive.classList.add("active");
        tabBtn.classList.add("active");
      });
    });

    if (descriptionTabContent.offsetHeight > 600) {
      descriptionTabContent.classList.add("closed");
    }

    descBtn.addEventListener("click", () => {
      descriptionTabContent.classList.toggle("closed");
      descBtn.classList.toggle("hidden");
      descLink.classList.toggle("hidden");
    });

    descLink.addEventListener("click", () => {
      descriptionTabContent.classList.toggle("closed");
      descBtn.classList.toggle("hidden");
      descLink.classList.toggle("hidden");
    });
  }
}
customElements.define("product-tabs", ProductTabs);

// Utils

/*----- Toggle Password Component -----*/
class TogglePassword extends HTMLElement {
  constructor() {
    super();
    if (this.dataset.inputId) {
      this.addEventListener("click", () => this.showHidePassword(this.dataset.inputId));
    }
  }

  showHidePassword(inputId) {
    var targetInput = document.getElementById(inputId);
    if (targetInput.type === "password") {
      targetInput.type = "text";
    } else {
      targetInput.type = "password";
    }
  }
}

customElements.define("toggle-password", TogglePassword);

document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.product__media-list.slider--mobile');
  const slides = slider?.children || [];
  if (!slider || slides.length < 2) return;

  const dotsContainer = document.createElement('div');
  dotsContainer.className = 'custom-dots';

  [...slides].forEach((_, index) => {
    const dot = document.createElement('span');
    dot.className = 'dot';
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => {
      slider.scrollTo({
        left: slider.offsetWidth * index,
        behavior: 'smooth'
      });
      updateDots(index);
    });
    dotsContainer.appendChild(dot);
  });

  slider.parentElement.appendChild(dotsContainer);

  function updateDots(activeIndex) {
    dotsContainer.querySelectorAll('.dot').forEach((dot, i) => {
      dot.classList.toggle('active', i === activeIndex);
    });
  }

  slider.addEventListener('scroll', () => {
    const index = Math.round(slider.scrollLeft / slider.offsetWidth);
    updateDots(index);
  });
});

